//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { defineComponent, onBeforeMount, ref, onBeforeUnmount, useContext, useStore } from '@nuxtjs/composition-api'
import useAuthRepository from '@/repositories/auth'
import EventBus, { EVENTS } from '@/services/eventBus'

export default defineComponent({
  setup() {
    const ctx = useContext()
    const hasScrolled = ref(false)

    const onWindowScroll = () => {
      hasScrolled.value = window.pageYOffset > 0
    }

    const store = useStore()

    const onLogoutClick = () => {
      store.dispatch('modals/open', {
        modalName: 'BaseConfirmModal',
        attrs: { title: ctx.i18n.t('logoutModal.description') }
      })
    }

    const authRepository = useAuthRepository(ctx)

    const onLogoutConfirm = () => {
      authRepository.logout()
        .then(() => store.dispatch('modals/close', 'BaseConfirmModal'))
    }

    onBeforeMount(() => {
      window.addEventListener('scroll', onWindowScroll)
      EventBus.$on(EVENTS.CONFIRM_MODAL_CONFIRM, onLogoutConfirm)
    })

    onBeforeUnmount(() => {
      window.removeEventListener('scroll', onWindowScroll)
      EventBus.$off(EVENTS.CONFIRM_MODAL_CONFIRM, onLogoutConfirm)
    })

    return {
      hasScrolled,
      onLogoutClick
    }
  }
})
